/**
 * A helper function with type-agnostic id
 * @param {T[]} entities - The array of items
 * @param {string | number | undefined} entityId - The id of what you're looking for
 */
export function getEntityById<T extends { id?: string | number | undefined | null }>(
  entities: T[] = [],
  entityId: string | number | undefined | null
): T | undefined {
  if (typeof entityId === 'undefined' || !entityId) return undefined
  return entities.find(e => {
    if (typeof e?.id === 'undefined' || !e.id) return undefined
    return `${e.id}` === `${entityId}`
  })
}

/**
 * Performs a comparison as strings
 * @param {string | number | undefined} id
 * @param {string | number | undefined} otherId
 */
export const isSameEntityId = (
  id: string | number | undefined,
  otherId: string | number | undefined
): boolean => {
  if (typeof id === 'undefined' || typeof otherId === 'undefined') return false
  return `${id}` === `${otherId}`
}
